import { render, staticRenderFns } from "./album_details.vue?vue&type=template&id=35ffa648&scoped=true&"
import script from "./album_details.vue?vue&type=script&lang=js&"
export * from "./album_details.vue?vue&type=script&lang=js&"
import style0 from "./album_details.vue?vue&type=style&index=0&id=35ffa648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffa648",
  null
  
)

export default component.exports